export default "__VITE_ASSET__JVVEq_y7__"